function PageActions({ className = "", children }) {
    return <div className={`my-4 flex  ${className}`}>{children}</div>;
}

export default PageActions;
